import React from 'react';
import ReactDOM from 'react-dom';


const dropbtn = {
    backgroundColor: "#f9f9f9",
    color: "black",
    //padding: 16,
    textAlign:"center",
    fontCize: 16,
    //border: "none",
    cursor: "pointer",
    wordWrap: "break-word",
    width: 160,
    height: 40,
    overflow:"hidden",
}

/* The container <div> - needed to position the dropdown content */
const dropdown = {
    position: "relative",
    display: "inline-block",
    backgroundColor: "#f9f9f9",

}

/* Dropdown Content (Hidden by Default) */
const dropdownContent = {
    display: "none",
    position: "absolute",
    backgroundColor: "#f9f9f9",
    minWidth: 160,
    zIndex: 1,
    maxHeight: 500,
    overflow:"scroll",
}

const dropDownElemStyle=
{
  margin:4,
	display:"block",
	backgroundColor:"#DDDDDD",
  border: "solid 1px",
  minWidth:80,
  textAlign:"center",
}

const dropDownElemStyleSelected= Object.assign({}, dropDownElemStyle, {backgroundColor:"#FFFFFF"});
/*
export class DropDownSelector extends React.Component {
   constructor(props)
   {
   	super(props);
   	this.state = {};
   	this.state.isShowingAll = false;
   	
   }

   clickedDropDown()
   {
   	console.log("Clicked");
   	this.setState({isShowingAll:!this.state.isShowingAll});
   }

   onSelect(id)
   {
   		this.props.onChange(id);
   		this.setState({isShowingAll:false});
   }

   render()
   {
   	const dropDownContentStyle = this.state.isShowingAll ?
   	Object.assign({}, dropdownContent, {display:"block"}) : dropdownContent;
  
    const currentObject = this.props.objects.find((obj)=>obj.id==this.props.value);
    
    const objectColumns = [];

   	return(
   		<div style={dropdown}>
   			<button style={dropbtn} onClick={this.clickedDropDown.bind(this)}>
   				{currentObject ? currentObject.name : ""}}
   			</button>
   			<div style={dropDownContentStyle}>
   				{this.props.objects.map((obj,i)=>
   					<div key={i}  onClick={()=>this.onSelect(obj.id)} style={obj.id==this.props.value ? dropDownElemStyleSelected : dropDownElemStyle}>
   						{obj.name}
   					</div>)}
   			</div>
   		</div>	
   		);
   }
}
*/
export class DropDownMultiSelector extends React.Component {
   constructor(props)
   {
    super(props);

    //Make single or multiple active ids into array
    const activeIds = this.props.selectSingle ? props.value != null ? [props.value] : [] : props.value;

    //Eliminate activeIds that are not present in object list (deleted from elsewhere)

    const activeIdsFiltered = activeIds.filter((id)=>{
      return props.objects.find((obj)=>{return obj.id === id});});


    this.state = {
      isShowingAll: false,
      activeIds: activeIdsFiltered,
      isShowingFixed: false,
      adaptNext: false,
    };

    this._buttonElem = null;

   this.getSortedObjects(props);
   
   }

   getSortedObjects(props)
   {
     this.objectsSorted = props.objects.sort((a,b)=>{return a.name >= b.name ? 1 : -1;});
   }

   clickedDropDown(show)
   {
    console.log("Clicked");
    this.setState({adaptNext:show});
    this.setState({isShowingAll:show});
    if(!show)
    {
      this.setState({isShowingFixed: false});
    }

   }

   onSelect(id)
   {
    if(this.props.selectSingle)
    {
      this.setState({activeIds:[id]});
      this.props.onChange(id);
      this.setState({isShowingAll:false});
    }
    else
    {
      const newActiveIds = this.state.activeIds.indexOf(id) == -1 ? [...this.state.activeIds, id] : this.state.activeIds.filter((i)=>i!=id);

      this.setState({activeIds:newActiveIds});
      this.props.onChange(newActiveIds);
    }
   }

   evaluateOVerflow(htmlElem)
   {
    if(this.state.adaptNext && htmlElem && this.state.isShowingAll)
    {
      const clientRect = htmlElem.getBoundingClientRect();
      const mustShowFixed = clientRect.top + clientRect.height > window.innerHeight;
      //console.log("top: " + clientRect.top + " height: " + clientRect.height + " offsetHeight: " + htmlElem.offsetHeight   + " screen height: " + screen.height + " mustShowFixed: " + mustShowFixed);
      this.setState({adaptNext:false});
      this.setState({isShowingFixed: mustShowFixed});
    }
   }

   componentWillUpdate(nextProps, nextState)
   {
    this.getSortedObjects(nextProps);
   }

   render()
   {
    const dropDownContentStyle = this.state.isShowingAll ?
    Object.assign({}, dropdownContent, {display:"flex"}) : dropdownContent;

    const dropDwnButtonText = this.state.activeIds.length == 0 ? "none" : this.state.activeIds.map((i)=>{const found = this.objectsSorted.find((obj)=>obj.id == i); return (found ? found.name : "(missing)") + ", ";});
    
    const dropDownAdaptedContentStyle = !this.state.isShowingFixed ? dropDownContentStyle :
      Object.assign({}, dropDownContentStyle, {left:this._buttonElem.getBoundingClientRect().right, position:"fixed", bottom:100});
    

    const objCount = this.objectsSorted.length;
    const maxCols = 5;

    const cols = Math.min(Math.max(1, Math.floor(Math.sqrt(objCount))), maxCols);

    const objsPrCol = Math.ceil(objCount / cols);

    const objectsInColumns = [];

    for(var i = 0; i < cols; i++)
    {
      objectsInColumns.push([]);
      for(var j = 0; j < objsPrCol; j++)
      {
        const index = objsPrCol * i + j;
        if(index >= objCount)
          break;
        objectsInColumns[i].push(this.objectsSorted[index])
      }
    }
   
    //if(dropDwnButtonText.length > 50)
    return(
      <div style={dropdown}>
        <button style={dropbtn} ref={(e)=>{if(e) this._buttonElem=e}} onClick={()=>this.clickedDropDown.bind(this)(!this.state.isShowingAll)}>
          {dropDwnButtonText}
        </button>
        <div style={dropDownAdaptedContentStyle}  ref={this.evaluateOVerflow.bind(this)}>
          {
            objectsInColumns.map((colObjs, i)=>
              <div key={i} style={{display:"inline-block", verticalAlign: "top"}}>
                {colObjs.map((obj,i)=>
                  <div key={i}
                    onClick={()=>this.onSelect(obj.id)} 
                    style={this.state.activeIds.indexOf(obj.id) != -1 ? dropDownElemStyleSelected : dropDownElemStyle}>
                      {obj.name}
                  </div>)
                }
          </div>
              )
          }
          

        </div>
      </div>  
      );
   }
}



// WEBPACK FOOTER //
// ./js/DropDownSelector.jsx